/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Person_Create_Assignment_LimitInputs */

const fr_person_create_assignment_limit = /** @type {(inputs: Person_Create_Assignment_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduisez la sélection à 100 clients et 10 000 affectations maximum. Vous pourrez en ajouter après la création.`)
};

const en_person_create_assignment_limit = /** @type {(inputs: Person_Create_Assignment_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select at most 100 clients and 10,000 assignments. You can add more after creation.`)
};

/**
* | output |
* | --- |
* | "Select at most 100 clients and 10,000 assignments. You can add more after creation." |
*
* @param {Person_Create_Assignment_LimitInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const person_create_assignment_limit = /** @type {((inputs?: Person_Create_Assignment_LimitInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Person_Create_Assignment_LimitInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_person_create_assignment_limit(inputs)
	return fr_person_create_assignment_limit(inputs)
});